import {Component, OnInit, ViewChild, ViewEncapsulation} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {AppScope} from "../services/app_scope.service";
import {User} from "../_models/users";
import {ApiService} from "../services/api/api.service";
import {HeaderDataService} from "../services/header_data.service";
import {SearchQueryOptions} from "../services/api/search-query-options";
import {SingleResponse} from '../services/api/response-types';
import {MatTabGroup} from "@angular/material/tabs";
import {ActivatedRoute} from "@angular/router";
import {take, tap} from "rxjs/operators";
import {NotificationService} from "../services/notification.service";
import {COMMON_DIALOG_IMPORTS, COMMON_FORM_IMPORTS} from "../shared/import-groups/Common";


@Component({
    selector: 'my-security',
    templateUrl: 'my-security.component.html',
    imports: [
    COMMON_DIALOG_IMPORTS,
    COMMON_FORM_IMPORTS
],
    encapsulation: ViewEncapsulation.None
})
export class MySecurityComponent implements OnInit {
    days: number;
    auth_token: any;
    errors: any[];
    user: any;

    @ViewChild('tab_group') tabGroup: MatTabGroup;

    constructor(private http: HttpClient,
                public appScope: AppScope,
                private headerData: HeaderDataService,
                private api: ApiService,
                private notification: NotificationService,
                private activatedRoute: ActivatedRoute) {
    }

    ngOnInit(): void {
        const ctrl = this;
        this.headerData.title = 'My Security';
        this.appScope.no_header = false;
        this.days = 90;
        this.fetchUser();
    }

    ngAfterViewInit() {
        let tabName = this.activatedRoute.snapshot.queryParams['tab'];
        this.tabGroup.selectedIndex = this.tabGroup._tabs.toArray().findIndex(t => t.textLabel === tabName);
    }

    fetchUser() {
        const options = new SearchQueryOptions();
        options.filters = [{name: 'id', op: 'eq', val: this.appScope.current_user.id}];
        this.appScope.auth_complete.promise.then(() => {
            this.api.users.searchSingle(options).pipe(take(1)).subscribe((response: SingleResponse<User>) => {
                this.user = response.data;
            });
        });
    }

    generateToken() {
        this.http.get('/api/auth/token/' + this.appScope.current_user.id + '/' + this.days * 24 * 3600).pipe(tap((response: any) => {
            this.appScope.current_user.auth_token_active = true;
            this.auth_token = response.token;
        })).subscribe();
    }

    deactivateToken() {
        const ctrl = this;
        this.http.get('/api/auth/deactivate_token/' + this.appScope.current_user.id).pipe(tap({
            next: response => {
                this.appScope.current_user.auth_token_active = false;
                console.log('deactivate auth token success', response);
        }, error: response => {
            console.log('deactivate auth token failure', response);
        }})).subscribe();
    }
}
